module.exports = __webpack_public_path__ + "static/media/laptop.1aee57ac.svg";